//LOCAL
// export const API_URL_LOCALE_BASE = "http://127.0.0.1:8000/api/";
const env = process.env.NODE_ENV === "development" ? false : true;
export const API_URL_LOCALE_BASE = env 

? "https://be-asupub-insight-chile-v2-bx2d675z4a-ue.a.run.app/api/"
: "https://be-asupub-insight-chile-v2-bx2d675z4a-ue.a.run.app/api/";

console.log(`ENV :: ${env}`)


/*
    const Local = {
         API_BASE_URL : 'http://127.0.0.1:8000'
    }
*/
// export const API_BASE_URL = env 
//                             ? 'https://be-asupub-insight-chile-bx2d675z4a-ue.a.run.app' 
//                             : 'http://127.0.0.1:8000';
